import $ from "jquery";

const postFaq = () => {
  const init = () => {
    faq();
  };

  const faq = () => {
    const el = {
      body: ".faq-item__body",
      header: ".faq-item__header",
      item: ".faq-item",
      icon: ".faq-item__header svg",
    };

    const plusIcon = `
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" rx="18" fill="#F5E2E4"/>
        <path d="M13 18H23" stroke="#CE132D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18 23V13" stroke="#CE132D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    const minusIcon = `
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" rx="18" fill="#F5E2E4"/>
        <path d="M13 18H23" stroke="#CE132D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    $(document).ready(function () {
      $(el.body).first().show();
      $(el.item).first().addClass("active");
      $(el.icon).first().replaceWith(minusIcon);

      $(el.header).on("click", function () {
        const parentItem = $(this).closest(el.item);

        if (parentItem.hasClass("active")) {
          // Self-close logic
          parentItem.removeClass("active");
          parentItem.find(el.body).slideUp();
          $(this).find("svg").replaceWith(plusIcon);
        } else {
          // Open the clicked FAQ item and close others
          $(el.item).removeClass("active");
          $(el.item).find(el.body).slideUp();
          $(el.item).find("svg").replaceWith(plusIcon);

          parentItem.addClass("active");
          parentItem.find(el.body).slideDown();
          $(this).find("svg").replaceWith(minusIcon);
        }
      });
    });
  };

  init();
};

try {
  postFaq();
} catch (e) {
  console.error("Post Faq: ", e);
}
